import { render, staticRenderFns } from "./PlanCards.vue?vue&type=template&id=6394e65a"
import script from "./PlanCards.vue?vue&type=script&lang=js"
export * from "./PlanCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6394e65a')) {
      api.createRecord('6394e65a', component.options)
    } else {
      api.reload('6394e65a', component.options)
    }
    module.hot.accept("./PlanCards.vue?vue&type=template&id=6394e65a", function () {
      api.rerender('6394e65a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plan-cards/PlanCards.vue"
export default component.exports